import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

// flex-layout-Ablösung: früher via fx*-Direktiven, jetzt reines CSS-Flexbox.
// Verhalten wie zuvor: Basis-Richtung aus to.fxLayout (default column), ab
// gt-xs (>=600px) immer row mit 15px Gap; Feldbreite aus templateOptions.fxFlex
// (default 100%) — via CSS-Variable, max-width nur im Row-Modus (>=600px).
@Component({
  selector: 'formly-form-flex',
  styles: [
    `
      /* MDC-Migration: Infix-Breite (frueher .mat-form-field-infix). */
      :host ::ng-deep .mat-mdc-form-field-infix {
        width: auto;
      }

      .content {
        display: flex;
        gap: 0;
        /* fxFlexFill */
        width: 100%;
        height: 100%;
      }

      .content > formly-field {
        flex-grow: 1;
        flex-shrink: 1;
        box-sizing: border-box;
        flex-basis: var(--ff-basis, 100%);
      }

      @media (min-width: 600px) {
        .content {
          flex-direction: row !important;
          gap: 15px;
        }

        .content > formly-field {
          max-width: var(--ff-basis, 100%);
        }
      }
    `,
  ],
  template: `
    <div class="content" [style.flex-direction]="to.fxLayout || 'column'">
      @for (f of field.fieldGroup; track f) {
        <formly-field
          [field]="f"
          [style.--ff-basis]="(f.templateOptions?.fxFlex || '100') + '%'"
        ></formly-field>
      }
    </div>
  `,
  standalone: false,
})
export class FlexLayoutType extends FieldType {}
